"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStateHex = exports.findSrcInfoV1 = exports.findSrcInfoV2 = exports.JSONStringify = exports.JSONParserSync = exports.JSONParser = exports.invert = exports.xor = exports.or = exports.and = exports.int2Number = exports.canAssignProperty = exports.arrayToLiteral = exports.structSign = exports.librarySign = exports.resolveGenericType = exports.inferrType = exports.cloneArray = exports.arrayToJson = exports.arrayToScryptType = exports.toScryptType = exports.parseAbiFromUnlockingScript = exports.buildPublicKeyHashScript = exports.buildOpreturnScript = exports.writeVarint = exports.toLEUnsigned = exports.len = exports.readLaunchJson = exports.hash256 = exports.sha256 = exports.hash160 = exports.parseGenericType = exports.isGenericType = exports.toHashedSet = exports.toHashedMap = exports.toData = exports.findKeyIndex = exports.sortset = exports.sortmap = exports.flattenSha256 = exports.deserializeArgfromState = exports.deserializeArgfromHex = exports.readBytes = exports.buildDefaultStateProps = exports.buildContractState = exports.buildContractCode = exports.findStatic = exports.findConstStatic = exports.isInteger = exports.toLiteral = exports.createArray = exports.createDefaultLibrary = exports.createLibraryProperties = exports.createLibrary = exports.createStruct = exports.stripAnsi = exports.ansiRegex = exports.resolveType = exports.resolveConstValue = exports.genLaunchConfigFile = exports.newCall = exports.compileContractAsync = exports.compileContract = exports.isEmpty = exports.readFileByLine = exports.typeOfArg = exports.flatternParams = exports.flatternStateArgs = exports.flatternCtorArgs = exports.flatternLibraryState = exports.flatternLibrary = exports.flatternStruct = exports.flatternArray = exports.subscript = exports.subArrayType = exports.toGenericType = exports.toLiteralArrayType = exports.arrayTypeAndSize = exports.arrayTypeAndSizeStr = exports.checkSupportedParamType = exports.checkStruct = exports.checkStructField = exports.findStructByType = exports.getNameByType = exports.isArrayType = exports.findStructByName = exports.literal2Asm = exports.uri2path = exports.path2uri = exports.isNode = exports.bin2num = exports.num2bin = exports.getLowSPreimage = exports.hashIsPositiveNumber = exports.getPreimage = exports.toHex = exports.signTx = exports.getValidatedHexString = exports.hexStringToBytes = exports.bytesToHexString = exports.bytes2Literal = exports.hex2ScryptType = exports.asm2ScryptType = exports.literal2ScryptType = exports.isStringLiteral = exports.parseLiteral = exports.intValue2hex = exports.int2Value = exports.hex2int = exports.asm2int = exports.int2Asm = exports.bool2Asm = exports.DEFAULT_SIGHASH_TYPE = exports.DEFAULT_FLAGS = exports.ECIES = exports.mvc = void 0;
var url_1 = require("url");
var mvc = require("mvc-lib");
exports.mvc = mvc;
var ECIES = require("mvc-lib/ecies");
exports.ECIES = ECIES;
var fs = require("fs");
var path_1 = require("path");
var os_1 = require("os");
var json_ext_1 = require("@discoveryjs/json-ext");
var sourcemap_codec_1 = require("sourcemap-codec");
var internal_1 = require("./internal");
var compilerWrapper_1 = require("./compilerWrapper");
var scryptTypes_1 = require("./scryptTypes");
var BN = mvc.crypto.BN;
var Interp = mvc.Script.Interpreter;
exports.DEFAULT_FLAGS = 
//Interp.SCRIPT_VERIFY_P2SH | Interp.SCRIPT_VERIFY_CLEANSTACK | // no longer applies now p2sh is deprecated: cleanstack only applies to p2sh
Interp.SCRIPT_ENABLE_MAGNETIC_OPCODES |
    Interp.SCRIPT_ENABLE_MONOLITH_OPCODES | // TODO: to be removed after upgrade to mvc 2.0
    Interp.SCRIPT_VERIFY_STRICTENC |
    Interp.SCRIPT_ENABLE_SIGHASH_FORKID |
    Interp.SCRIPT_VERIFY_LOW_S |
    Interp.SCRIPT_VERIFY_NULLFAIL |
    Interp.SCRIPT_VERIFY_DERSIG |
    Interp.SCRIPT_VERIFY_MINIMALDATA |
    Interp.SCRIPT_VERIFY_NULLDUMMY |
    Interp.SCRIPT_VERIFY_DISCOURAGE_UPGRADABLE_NOPS |
    Interp.SCRIPT_VERIFY_CHECKLOCKTIMEVERIFY |
    Interp.SCRIPT_VERIFY_CHECKSEQUENCEVERIFY |
    Interp.SCRIPT_VERIFY_CLEANSTACK;
exports.DEFAULT_SIGHASH_TYPE = mvc.crypto.Signature.SIGHASH_ALL | mvc.crypto.Signature.SIGHASH_FORKID;
function bool2Asm(str) {
    if (str === 'true') {
        return 'OP_TRUE';
    }
    if (str === 'false') {
        return 'OP_FALSE';
    }
    throw new Error("invalid str '" + str + "' to convert to bool");
}
exports.bool2Asm = bool2Asm;
/**
 * decimal or hex int to little-endian signed magnitude
 */
function int2Asm(str) {
    if (/^(-?\d+)$/.test(str) || /^0x([0-9a-fA-F]+)$/.test(str)) {
        var number = str.startsWith('0x') ? new BN(str.substring(2), 16) : new BN(str, 10);
        if (number.eqn(-1)) {
            return 'OP_1NEGATE';
        }
        if (number.gten(0) && number.lten(16)) {
            return 'OP_' + number.toString();
        }
        var m = number.toSM({ endian: 'little' });
        return m.toString('hex');
    }
    else {
        throw new Error("invalid str '" + str + "' to convert to int");
    }
}
exports.int2Asm = int2Asm;
/**
 * convert asm string to number or bigint
 */
function asm2int(str) {
    switch (str) {
        case 'OP_1NEGATE':
            return -1;
        case '0':
        case 'OP_0':
        case 'OP_1':
        case 'OP_2':
        case 'OP_3':
        case 'OP_4':
        case 'OP_5':
        case 'OP_6':
        case 'OP_7':
        case 'OP_8':
        case 'OP_9':
        case 'OP_10':
        case 'OP_11':
        case 'OP_12':
        case 'OP_13':
        case 'OP_14':
        case 'OP_15':
        case 'OP_16':
            return parseInt(str.replace('OP_', ''));
        default: {
            var value = getValidatedHexString(str);
            var bn = BN.fromHex(value, {
                endian: 'little',
            });
            if (bn.toNumber() < Number.MAX_SAFE_INTEGER && bn.toNumber() > Number.MIN_SAFE_INTEGER) {
                return bn.toNumber();
            }
            else {
                return bn.toString();
            }
        }
    }
}
exports.asm2int = asm2int;
/**
 * convert asm string to number or bigint
 */
function hex2int(str) {
    var b = mvc.Script.fromHex(str);
    var chuck = b.chunks[0];
    switch (chuck.opcodenum) {
        case 0:
            return 0;
        case 79:
            return -1;
        case 81:
        case 82:
        case 83:
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 89:
        case 90:
        case 91:
        case 92:
        case 93:
        case 94:
        case 95:
        case 96:
            return chuck.opcodenum - 80;
        default: {
            var value = chuck.buf.toString('hex');
            var bn = BN.fromHex(value, {
                endian: 'little',
            });
            if (bn.toNumber() < Number.MAX_SAFE_INTEGER && bn.toNumber() > Number.MIN_SAFE_INTEGER) {
                return bn.toNumber();
            }
            else {
                return bn.toString();
            }
        }
    }
}
exports.hex2int = hex2int;
/**
 * decimal int or hex str to number or bigint
 */
function int2Value(str) {
    if (/^(-?\d+)$/.test(str) || /^0x([0-9a-fA-F]+)$/.test(str)) {
        var bn = str.startsWith('0x') ? new BN(str.substring(2), 16) : new BN(str, 10);
        if (bn.toNumber() < Number.MAX_SAFE_INTEGER && bn.toNumber() > Number.MIN_SAFE_INTEGER) {
            return bn.toNumber();
        }
        else {
            return str;
        }
    }
    else {
        throw new Error("invalid str '" + str + "' to convert to int");
    }
}
exports.int2Value = int2Value;
function intValue2hex(val) {
    var hex = val.toString(16);
    if (hex.length % 2 === 1) {
        hex = '0' + hex;
    }
    return hex;
}
exports.intValue2hex = intValue2hex;
function parseBytesLiteral(hex) {
    var hexString = getValidatedHexString(hex);
    if (hexString === '') {
        return ['OP_0', hexString, internal_1.VariableType.BYTES];
    }
    if (hexString.length / 2 > 1) {
        return [hexString, hexString, internal_1.VariableType.BYTES];
    }
    var intValue = parseInt(hexString, 16);
    if (intValue >= 1 && intValue <= 16) {
        return ["OP_" + intValue, hexString, internal_1.VariableType.BYTES];
    }
    return [hexString, hexString, internal_1.VariableType.BYTES];
}
function parseLiteral(l) {
    // bool
    if (l === 'false') {
        return ['OP_FALSE', false, internal_1.VariableType.BOOL];
    }
    if (l === 'true') {
        return ['OP_TRUE', true, internal_1.VariableType.BOOL];
    }
    // hex int
    var m = /^(0x[0-9a-fA-F]+)$/.exec(l);
    if (m) {
        return [int2Asm(m[1]), int2Value(m[1]), internal_1.VariableType.INT];
    }
    // decimal int
    m = /^(-?\d+)$/.exec(l);
    if (m) {
        return [int2Asm(m[1]), int2Value(m[1]), internal_1.VariableType.INT];
    }
    // bytes
    // note: special handling of empty bytes b''
    m = /^b'([\da-fA-F]*)'$/.exec(l);
    if (m) {
        return parseBytesLiteral(m[1]);
    }
    // String
    m = /^"([\s\S]*)"$/.exec(l);
    if (m) {
        var value = scryptTypes_1.String.toUtf8Hex(m[1]);
        return parseBytesLiteral(value);
    }
    // PrivKey
    // 1) decimal int
    m = /^PrivKey\((-?\d+)\)$/.exec(l);
    if (m) {
        return [int2Asm(m[1]), int2Value(m[1]), internal_1.VariableType.PRIVKEY];
    }
    // 2) hex int
    m = /^PrivKey\((0x[0-9a-fA-F]+)\)$/.exec(l);
    if (m) {
        return [int2Asm(m[1]), int2Value(m[1]), internal_1.VariableType.PRIVKEY];
    }
    // PubKey
    m = /^PubKey\(b'([\da-fA-F]+)'\)$/.exec(l);
    if (m) {
        var value = getValidatedHexString(m[1]);
        return [value, value, internal_1.VariableType.PUBKEY];
    }
    // Sig
    m = /^Sig\(b'([\da-fA-F]+)'\)$/.exec(l);
    if (m) {
        var value = getValidatedHexString(m[1]);
        return [value, value, internal_1.VariableType.SIG];
    }
    // Ripemd160
    m = /^Ripemd160\(b'([\da-fA-F]+)'\)$/.exec(l);
    if (m) {
        var value = getValidatedHexString(m[1]);
        return [value, value, internal_1.VariableType.RIPEMD160];
    }
    // Sha1
    m = /^Sha1\(b'([\da-fA-F]+)'\)$/.exec(l);
    if (m) {
        var value = getValidatedHexString(m[1]);
        return [value, value, internal_1.VariableType.SHA1];
    }
    // Sha256
    m = /^Sha256\(b'([\da-fA-F]+)'\)$/.exec(l);
    if (m) {
        var value = getValidatedHexString(m[1]);
        return [value, value, internal_1.VariableType.SHA256];
    }
    // SigHashType
    m = /^SigHashType\(b'([\da-fA-F]+)'\)$/.exec(l);
    if (m) {
        var bn = new BN(getValidatedHexString(m[1]), 16);
        return [bn.toString('hex', 2), bn.toNumber(), internal_1.VariableType.SIGHASHTYPE];
    }
    // SigHashPreimage
    m = /^SigHashPreimage\(b'([\da-fA-F]+)'\)$/.exec(l);
    if (m) {
        var value = getValidatedHexString(m[1]);
        return [value, value, internal_1.VariableType.SIGHASHPREIMAGE];
    }
    // OpCodeType
    m = /^OpCodeType\(b'([\da-fA-F]+)'\)$/.exec(l);
    if (m) {
        var value = getValidatedHexString(m[1]);
        return [value, value, internal_1.VariableType.OPCODETYPE];
    }
    // Struct
    m = /^\{([\s\S]*)\}$/.exec(l);
    if (m) {
        // we use object to constructor a struct, no use literal, so here we return empty
        return ['', '', internal_1.VariableType.STRUCT];
    }
    // Library
    m = /^\[([\s\S]*)\]$/.exec(l);
    if (m) {
        // we use array to constructor a library, no use literal, so here we return empty
        return ['', '', internal_1.VariableType.LIBRARY];
    }
    throw new Error("<" + l + "> cannot be cast to ASM format, only sCrypt native types supported");
}
exports.parseLiteral = parseLiteral;
function isStringLiteral(l) {
    var m = /^"([\s\S]*)"$/.exec(l.trim());
    if (m) {
        return true;
    }
    return false;
}
exports.isStringLiteral = isStringLiteral;
/**
 * convert literals to Scrypt Type
 */
function literal2ScryptType(l) {
    var _a = __read(parseLiteral(l), 3), asm = _a[0], value = _a[1], type = _a[2];
    switch (type) {
        case internal_1.VariableType.BOOL:
            return new internal_1.Bool(value);
        case internal_1.VariableType.INT:
            return new internal_1.Int(value);
        case internal_1.VariableType.BYTES:
            return isStringLiteral(l) ? new scryptTypes_1.String(scryptTypes_1.String.fromUtf8Hex(value)) : new internal_1.Bytes(value);
        case internal_1.VariableType.PRIVKEY:
            return new internal_1.PrivKey(value);
        case internal_1.VariableType.PUBKEY:
            return new internal_1.PubKey(value);
        case internal_1.VariableType.SIG:
            return new internal_1.Sig(value);
        case internal_1.VariableType.RIPEMD160:
            return new internal_1.Ripemd160(value);
        case internal_1.VariableType.SHA1:
            return new internal_1.Sha1(value);
        case internal_1.VariableType.SHA256:
            return new internal_1.Sha256(value);
        case internal_1.VariableType.SIGHASHTYPE:
            return new internal_1.SigHashType(value);
        case internal_1.VariableType.SIGHASHPREIMAGE:
            return new internal_1.SigHashPreimage(value);
        case internal_1.VariableType.OPCODETYPE:
            return new internal_1.OpCodeType(value);
        default:
            throw new Error("<" + l + "> cannot be cast to ScryptType, only sCrypt native types supported");
    }
}
exports.literal2ScryptType = literal2ScryptType;
function asm2ScryptType(type, asm) {
    switch (type) {
        case internal_1.VariableType.BOOL:
            return new internal_1.Bool(BN.fromString(asm) > 0 ? true : false);
        case internal_1.VariableType.INT:
            return new internal_1.Int(asm2int(asm));
        case internal_1.VariableType.BYTES:
            return new internal_1.Bytes(asm == '0' || asm == 'OP_0' || asm == 'OP_FALSE' ? '' : asm);
        case internal_1.VariableType.PRIVKEY:
            return new internal_1.PrivKey(asm2int(asm));
        case internal_1.VariableType.PUBKEY:
            return new internal_1.PubKey(asm);
        case internal_1.VariableType.SIG:
            return new internal_1.Sig(asm);
        case internal_1.VariableType.RIPEMD160:
            return new internal_1.Ripemd160(asm);
        case internal_1.VariableType.SHA1:
            return new internal_1.Sha1(asm);
        case internal_1.VariableType.SHA256:
            return new internal_1.Sha256(asm);
        case internal_1.VariableType.SIGHASHTYPE:
            return new internal_1.SigHashType(asm2int(asm));
        case internal_1.VariableType.SIGHASHPREIMAGE:
            return new internal_1.SigHashPreimage(asm);
        case internal_1.VariableType.OPCODETYPE:
            return new internal_1.OpCodeType(asm);
        default:
            throw new Error("<" + type + "> cannot be cast to ScryptType, only sCrypt native types supported");
    }
}
exports.asm2ScryptType = asm2ScryptType;
function hex2ScryptType(type, hex) {
    var b = mvc.Script.fromHex(hex);
    var chuck = b.chunks[0];
    switch (type) {
        case internal_1.VariableType.BOOL:
            return new internal_1.Bool(chuck.opcodenum == 0x51 ? true : false);
        case internal_1.VariableType.INT:
            return new internal_1.Int(hex2int(hex));
        case internal_1.VariableType.BYTES:
            return new internal_1.Bytes(chuck.opcodenum == 0 ? '' : chuck.buf.toString('hex'));
        case internal_1.VariableType.PRIVKEY:
            return new internal_1.PrivKey(hex2int(hex));
        case internal_1.VariableType.PUBKEY:
            return new internal_1.PubKey(chuck.opcodenum == 0 ? '' : chuck.buf.toString('hex'));
        case internal_1.VariableType.SIG:
            return new internal_1.Sig(chuck.opcodenum == 0 ? '' : chuck.buf.toString('hex'));
        case internal_1.VariableType.RIPEMD160:
            return new internal_1.Ripemd160(chuck.opcodenum == 0 ? '' : chuck.buf.toString('hex'));
        case internal_1.VariableType.SHA1:
            return new internal_1.Sha1(chuck.opcodenum == 0 ? '' : chuck.buf.toString('hex'));
        case internal_1.VariableType.SHA256:
            return new internal_1.Sha256(chuck.opcodenum == 0 ? '' : chuck.buf.toString('hex'));
        case internal_1.VariableType.SIGHASHTYPE:
            return new internal_1.SigHashType(hex2int(hex));
        case internal_1.VariableType.SIGHASHPREIMAGE:
            return new internal_1.SigHashPreimage(chuck.opcodenum == 0 ? '' : chuck.buf.toString('hex'));
        case internal_1.VariableType.OPCODETYPE:
            return new internal_1.OpCodeType(chuck.opcodenum == 0 ? '' : chuck.buf.toString('hex'));
        default:
            throw new Error("<" + type + "> cannot be cast to ScryptType, only sCrypt native types supported");
    }
}
exports.hex2ScryptType = hex2ScryptType;
function bytes2Literal(bytearray, type) {
    switch (type) {
        case 'bool':
            return BN.fromBuffer(bytearray, { endian: 'little' }) > 0 ? 'true' : 'false';
        case 'int':
        case 'PrivKey':
            return BN.fromSM(bytearray, { endian: 'little' }).toString();
        case 'bytes':
            return "b'" + bytesToHexString(bytearray) + "'";
        default:
            return "b'" + bytesToHexString(bytearray) + "'";
    }
}
exports.bytes2Literal = bytes2Literal;
function bytesToHexString(bytearray) {
    return bytearray.reduce(function (o, c) {
        return (o += ('0' + (c & 0xff).toString(16)).slice(-2));
    }, '');
}
exports.bytesToHexString = bytesToHexString;
function hexStringToBytes(hex) {
    getValidatedHexString(hex);
    return hex
        .split('')
        .reduce(function (o, c, i) {
        if (i % 2 === 0) {
            o.push(c);
        }
        else {
            o[o.length - 1] += c;
        }
        return o;
    }, new Array())
        .map(function (b) { return parseInt(b, 16); });
}
exports.hexStringToBytes = hexStringToBytes;
function getValidatedHexString(hex, allowEmpty) {
    if (allowEmpty === void 0) { allowEmpty = true; }
    var ret = hex.trim();
    if (ret.length < 1 && !allowEmpty) {
        throw new Error('can\'t be empty string');
    }
    if (ret.length % 2) {
        throw new Error(ret + " should have even length");
    }
    if (ret.length > 0 && !/^[\da-f]+$/i.test(ret)) {
        throw new Error(ret + " should only contain [0-9] or characters [a-fA-F]");
    }
    return ret;
}
exports.getValidatedHexString = getValidatedHexString;
function signTx(tx, privateKey, lockingScript, inputAmount, inputIndex, sighashType, flags) {
    if (inputIndex === void 0) { inputIndex = 0; }
    if (sighashType === void 0) { sighashType = exports.DEFAULT_SIGHASH_TYPE; }
    if (flags === void 0) { flags = exports.DEFAULT_FLAGS; }
    if (!tx) {
        throw new Error('param tx can not be empty');
    }
    if (!privateKey) {
        throw new Error('param privateKey can not be empty');
    }
    if (!lockingScript) {
        throw new Error('param lockingScript can not be empty');
    }
    if (!inputAmount) {
        throw new Error('param inputAmount can not be empty');
    }
    if (typeof lockingScript === 'string') {
        throw new Error('Breaking change: LockingScript in ASM format is no longer supported, please use the lockingScript object directly');
    }
    var buf = toHex(mvc.Transaction.sighash
        .sign(tx, privateKey, sighashType, inputIndex, lockingScript, new mvc.crypto.BN(inputAmount), flags)
        .toTxFormat());
    return new internal_1.Sig(buf);
}
exports.signTx = signTx;
function toHex(x) {
    if (x instanceof internal_1.ScryptType) {
        return x.serialize();
    }
    return x.toString('hex');
}
exports.toHex = toHex;
function getPreimage(tx, lockingScript, inputAmount, inputIndex, sighashType, flags) {
    if (inputIndex === void 0) { inputIndex = 0; }
    if (sighashType === void 0) { sighashType = exports.DEFAULT_SIGHASH_TYPE; }
    if (flags === void 0) { flags = exports.DEFAULT_FLAGS; }
    var preimageBuf = mvc.Transaction.sighash.sighashPreimage(tx, sighashType, inputIndex, lockingScript, new mvc.crypto.BN(inputAmount), flags);
    return new internal_1.SigHashPreimage(preimageBuf.toString('hex'));
}
exports.getPreimage = getPreimage;
var MSB_THRESHOLD = 0x7e;
function hashIsPositiveNumber(sighash) {
    var highByte = sighash.readUInt8(31);
    return highByte < MSB_THRESHOLD;
}
exports.hashIsPositiveNumber = hashIsPositiveNumber;
function getLowSPreimage(tx, lockingScript, inputAmount, inputIndex, sighashType, flags) {
    if (inputIndex === void 0) { inputIndex = 0; }
    if (sighashType === void 0) { sighashType = exports.DEFAULT_SIGHASH_TYPE; }
    if (flags === void 0) { flags = exports.DEFAULT_FLAGS; }
    for (var i = 0; i < Number.MAX_SAFE_INTEGER; i++) {
        var preimage = getPreimage(tx, lockingScript, inputAmount, inputIndex, sighashType, flags);
        var sighash = mvc.crypto.Hash.sha256sha256(Buffer.from(toHex(preimage), 'hex'));
        var msb = sighash.readUInt8();
        if (msb < MSB_THRESHOLD && hashIsPositiveNumber(sighash)) {
            return preimage;
        }
        tx.inputs[inputIndex].sequenceNumber--;
    }
}
exports.getLowSPreimage = getLowSPreimage;
// Converts a number into a sign-magnitude representation of certain size as a string
// Throws if the number cannot be accommodated
// Often used to append numbers to OP_RETURN, which are read in contracts
// Support Bigint
function num2bin(n, dataLen) {
    var num = new BN(n);
    if (num.eqn(0)) {
        return '00'.repeat(dataLen);
    }
    var s = num.toSM({ endian: 'little' }).toString('hex');
    var byteLen_ = s.length / 2;
    if (byteLen_ > dataLen) {
        throw new Error(n + " cannot fit in " + dataLen + " byte[s]");
    }
    if (byteLen_ === dataLen) {
        return s;
    }
    var paddingLen = dataLen - byteLen_;
    var lastByte = s.substring(s.length - 2);
    var rest = s.substring(0, s.length - 2);
    var m = parseInt(lastByte, 16);
    if (num.isNeg) {
        // reset sign bit
        m &= 0x7f;
    }
    var mHex = m.toString(16);
    if (mHex.length < 2) {
        mHex = '0' + mHex;
    }
    var padding = n > 0 ? '00'.repeat(paddingLen) : '00'.repeat(paddingLen - 1) + '80';
    return rest + mHex + padding;
}
exports.num2bin = num2bin;
//Support Bigint
function bin2num(s) {
    var hex = s.toString('hex');
    var lastByte = hex.substring(hex.length - 2);
    var rest = hex.substring(0, hex.length - 2);
    var m = parseInt(lastByte, 16);
    var n = m & 0x7f;
    var nHex = n.toString(16);
    if (nHex.length < 2) {
        nHex = '0' + nHex;
    }
    //Support negative number
    var bn = BN.fromHex(rest + nHex, { endian: 'little' });
    if (m >> 7) {
        bn = bn.neg();
    }
    if (bn.toNumber() < Number.MAX_SAFE_INTEGER && bn.toNumber() > Number.MIN_SAFE_INTEGER) {
        return bn.toNumber();
    }
    else {
        return bn.toString();
    }
}
exports.bin2num = bin2num;
function isNode() {
    return typeof window === 'undefined' && typeof process === 'object';
}
exports.isNode = isNode;
function path2uri(path) {
    if (isNode()) {
        return url_1.pathToFileURL(path).toString();
    }
    else {
        return path;
    }
}
exports.path2uri = path2uri;
function uri2path(uri) {
    if (isNode()) {
        return url_1.fileURLToPath(uri);
    }
    else {
        return uri;
    }
}
exports.uri2path = uri2path;
/**
 * @deprecated
 * convert literals to script ASM format
 */
function literal2Asm(l) {
    var _a = __read(parseLiteral(l), 3), asm = _a[0], _ = _a[1], type = _a[2];
    return [asm, type];
}
exports.literal2Asm = literal2Asm;
function findStructByName(name, s) {
    return s.find(function (s) {
        return s.name == name;
    });
}
exports.findStructByName = findStructByName;
// test Token[3], int[3], st.b.c[3]
function isArrayType(type) {
    return /^(.+)(\[[\w.]+\])+$/.test(type);
}
exports.isArrayType = isArrayType;
function getNameByType(type) {
    if (isArrayType(type)) {
        var _a = __read(arrayTypeAndSizeStr(type), 2), elemType = _a[0], _ = _a[1];
        return getNameByType(elemType);
    }
    if (isGenericType(type)) {
        var _b = __read(parseGenericType(type), 2), tn = _b[0], _ = _b[1];
        return getNameByType(tn);
    }
    return type;
}
exports.getNameByType = getNameByType;
function findStructByType(type, s) {
    var name = getNameByType(type);
    if (name) {
        return findStructByName(name, s);
    }
    return undefined;
}
exports.findStructByType = findStructByType;
function checkStructField(s, param, arg, typeResolver) {
    var expectedType = typeResolver(param.type).finalType;
    if (isArrayType(expectedType)) {
        if (checkArray(arg, param, expectedType, typeResolver)) {
            throw new Error("Member " + param.name + " of struct " + s.name + " is of wrong type, expected " + param.type);
        }
    }
    else {
        var realType = typeOfArg(arg);
        if (expectedType != realType) {
            throw new Error("Member " + param.name + " of struct " + s.name + " is of wrong type, expected " + expectedType + " but got " + realType);
        }
    }
}
exports.checkStructField = checkStructField;
function checkStruct(s, arg) {
    s.params.forEach(function (p) {
        var member = arg.memberByKey(p.name);
        if (!member) {
            throw new Error("argument of type struct " + s.name + " missing member " + p.name);
        }
    });
    var members = s.params.map(function (p) { return p.name; });
    arg.getMembers().forEach(function (key) {
        if (!members.includes(key)) {
            throw new Error(key + " is not a member of struct " + s.name);
        }
    });
}
exports.checkStruct = checkStruct;
function checkSupportedParamType(arg, param, resolver) {
    var typeInfo = resolver(param.type);
    var finalType = typeInfo.finalType;
    if (isArrayType(finalType)) {
        return checkArray(arg, param, finalType, resolver);
    }
    var error = new Error("The type of " + param.name + " is wrong, expected " + finalType + " but got " + typeOfArg(arg));
    if (isGenericType(finalType)) {
        if (scryptTypes_1.Library.isLibrary(arg)) {
            var argL = arg;
            if (!argL.inferrTypesByAssign(finalType)) {
                return error;
            }
        }
        else if (internal_1.Struct.isStruct(arg)) {
            var argS = arg;
            if (!argS.inferrTypesByAssign(finalType)) {
                return error;
            }
        }
        else {
            return error;
        }
    }
    var t = typeOfArg(arg);
    return t == finalType ? undefined : error;
}
exports.checkSupportedParamType = checkSupportedParamType;
/**
 * return eg. int[N][N][4] => ['int', ["N","N","4"]]
 * @param arrayTypeName
 */
function arrayTypeAndSizeStr(arrayTypeName) {
    var arraySizes = [];
    if (arrayTypeName.indexOf('>') > -1) {
        var elemTypeName_1 = arrayTypeName.substring(0, arrayTypeName.lastIndexOf('>') + 1);
        var sizeParts = arrayTypeName.substring(arrayTypeName.lastIndexOf('>') + 1);
        __spread(sizeParts.matchAll(/\[([\w.]+)\]+/g)).map(function (match) {
            arraySizes.push(match[1]);
        });
        return [elemTypeName_1, arraySizes];
    }
    __spread(arrayTypeName.matchAll(/\[([\w.]+)\]+/g)).map(function (match) {
        arraySizes.push(match[1]);
    });
    var group = arrayTypeName.split('[');
    var elemTypeName = group[0];
    return [elemTypeName, arraySizes];
}
exports.arrayTypeAndSizeStr = arrayTypeAndSizeStr;
/**
 * return eg. int[2][3][4] => ['int', [2,3,4]]
 * @param arrayTypeName  eg. int[2][3][4]
 */
function arrayTypeAndSize(arrayTypeName) {
    var _a = __read(arrayTypeAndSizeStr(arrayTypeName), 2), elemTypeName = _a[0], arraySizes = _a[1];
    return [
        elemTypeName,
        arraySizes.map(function (size) {
            var n = parseInt(size);
            if (isNaN(n)) {
                throw new Error("arrayTypeAndSize error type " + arrayTypeName + " with sub isNaN");
            }
            return n;
        }),
    ];
}
exports.arrayTypeAndSize = arrayTypeAndSize;
function toLiteralArrayType(elemTypeName, sizes) {
    return [elemTypeName, sizes.map(function (size) { return "[" + size + "]"; }).join('')].join('');
}
exports.toLiteralArrayType = toLiteralArrayType;
function toGenericType(name, genericTypes) {
    return name + "<" + genericTypes.join(',') + ">";
}
exports.toGenericType = toGenericType;
/**
 * return eg. int[2][3][4] => int[3][4]
 * @param arrayTypeName  eg. int[2][3][4]
 */
function subArrayType(arrayTypeName) {
    var _a = __read(arrayTypeAndSize(arrayTypeName), 2), elemTypeName = _a[0], sizes = _a[1];
    return toLiteralArrayType(elemTypeName, sizes.slice(1));
}
exports.subArrayType = subArrayType;
function checkArray(args, param, expectedType, resolver) {
    var finalType = resolver(param.type).finalType;
    var _a = __read(arrayTypeAndSize(finalType), 2), elemTypeName = _a[0], arraySizes = _a[1];
    if (!Array.isArray(args)) {
        return new Error("The type of " + param.name + " is wrong, expected " + expectedType + " but got " + typeOfArg(args));
    }
    var t = typeOfArg(args[0]);
    if (!args.every(function (arg) { return typeOfArg(arg) === t; })) {
        return new Error("The type of " + param.name + " is wrong, expected " + expectedType + " but not all element types are the same");
    }
    if (args.length !== arraySizes[0]) {
        return new Error("The type of " + param.name + " is wrong, should be " + expectedType);
    }
    if (arraySizes.length == 1) {
        var arg0 = args[0];
        var scryptType = typeOfArg(arg0);
        return scryptType === elemTypeName
            ? undefined
            : new Error("The type of " + param.name + " is wrong, should be " + expectedType);
    }
    else {
        return args
            .map(function (a) {
            return checkArray(a, {
                name: param.name,
                type: subArrayType(finalType),
            }, expectedType, resolver);
        })
            .filter(function (e) { return e; })[0];
    }
}
function subscript(index, arraySizes) {
    if (arraySizes.length == 1) {
        return "[" + index + "]";
    }
    else if (arraySizes.length > 1) {
        var subArraySizes = arraySizes.slice(1);
        var offset = subArraySizes.reduce(function (acc, val) {
            return acc * val;
        }, 1);
        return "[" + Math.floor(index / offset) + "]" + subscript(index % offset, subArraySizes);
    }
}
exports.subscript = subscript;
function flatternArray(arg, name, finalType) {
    if (!Array.isArray(arg)) {
        throw new Error('flatternArray only work on array');
    }
    var _a = __read(arrayTypeAndSize(finalType), 2), elemTypeName = _a[0], arraySizes = _a[1];
    return arg
        .map(function (item, index) {
        if (typeof item === 'boolean') {
            item = new internal_1.Bool(item);
        }
        else if (typeof item === 'number') {
            item = new internal_1.Int(item);
        }
        else if (typeof item === 'bigint') {
            item = new internal_1.Int(item);
        }
        else if (Array.isArray(item)) {
            return flatternArray(item, name + "[" + index + "]", subArrayType(finalType));
        }
        else if (internal_1.Struct.isStruct(item)) {
            return flatternStruct(item, name + "[" + index + "]");
        }
        else if (scryptTypes_1.Library.isLibrary(item)) {
            return flatternLibrary(item, name + "[" + index + "]");
        }
        else {
            item = item;
        }
        return {
            value: item,
            name: "" + name + subscript(index, arraySizes),
            type: elemTypeName,
        };
    })
        .flat(Infinity);
}
exports.flatternArray = flatternArray;
function flatternStruct(arg, name) {
    if (internal_1.Struct.isStruct(arg)) {
        var argS_1 = arg;
        var keys = argS_1.getMembers();
        return keys
            .map(function (key) {
            var member = argS_1.memberByKey(key);
            if (internal_1.Struct.isStruct(member)) {
                return flatternStruct(member, name + "." + key);
            }
            else if (Array.isArray(member)) {
                var finalType = argS_1.getMemberAstFinalType(key);
                return flatternArray(member, name + "." + key, finalType);
            }
            else {
                member = member;
                return {
                    value: member,
                    name: name + "." + key,
                    type: member.type,
                };
            }
        })
            .flat(Infinity);
    }
    else {
        throw new Error(arg + " should be struct");
    }
}
exports.flatternStruct = flatternStruct;
function flatternLibrary(arg, name) {
    if (scryptTypes_1.Library.isLibrary(arg)) {
        var library = arg;
        var args_1 = library.getCtorArgs();
        return library
            .getLibraryAst()
            .params.map(function (param, index) {
            var arg = args_1[index];
            if (internal_1.Struct.isStruct(arg)) {
                return flatternStruct(arg, name + "." + param.name);
            }
            else if (Array.isArray(arg)) {
                return flatternArray(arg, name + "." + param.name, param.type);
            }
            else if (scryptTypes_1.Library.isLibrary(arg)) {
                return flatternLibrary(arg, name + "." + param.name);
            }
            else {
                return {
                    value: arg,
                    name: name + "." + param.name,
                    type: param.type,
                };
            }
        })
            .flat(Infinity);
    }
    else {
        throw new Error(arg + " should be library");
    }
}
exports.flatternLibrary = flatternLibrary;
function flatternLibraryState(arg, name) {
    if (scryptTypes_1.Library.isLibrary(arg)) {
        var library_1 = arg;
        return library_1
            .getLibraryAst()
            .properties.map(function (param, index) {
            var property = library_1.getProperty(param.name);
            if (internal_1.Struct.isStruct(property)) {
                return flatternStruct(property, name + "." + param.name);
            }
            else if (Array.isArray(property)) {
                return flatternArray(property, name + "." + param.name, param.type);
            }
            else if (scryptTypes_1.Library.isLibrary(property)) {
                return flatternLibraryState(property, name + "." + param.name);
            }
            else {
                return {
                    value: property,
                    name: name + "." + param.name,
                    type: param.type,
                };
            }
        })
            .flat(Infinity);
    }
    else {
        throw new Error(arg + " should be library");
    }
}
exports.flatternLibraryState = flatternLibraryState;
//using for flattern contract constructor arguments
function flatternCtorArgs(args, resolver) {
    var args_ = [];
    args.forEach(function (arg) {
        var typeInfo = resolver(arg.type);
        if (isArrayType(typeInfo.finalType)) {
            flatternArray(arg.value, arg.name, typeInfo.finalType).forEach(function (e) {
                args_.push({
                    name: e.name,
                    type: resolver(e.type).finalType,
                    value: e.value,
                });
            });
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
            flatternStruct(arg.value, arg.name).forEach(function (e) {
                args_.push({
                    name: e.name,
                    type: resolver(e.type).finalType,
                    value: e.value,
                });
            });
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
            flatternLibrary(arg.value, arg.name).forEach(function (e) {
                args_.push({
                    name: e.name,
                    type: resolver(e.type).finalType,
                    value: e.value,
                });
            });
        }
        else {
            args_.push({
                name: arg.name,
                type: typeInfo.finalType,
                value: arg.value,
            });
        }
    });
    return args_;
}
exports.flatternCtorArgs = flatternCtorArgs;
//using for flattern stateful contract states
function flatternStateArgs(args, resolver) {
    var args_ = [];
    args.forEach(function (arg) {
        var typeInfo = resolver(arg.type);
        var finalType = typeInfo.finalType;
        if (isArrayType(finalType)) {
            flatternArray(arg.value, arg.name, finalType).forEach(function (e) {
                args_.push({
                    name: e.name,
                    type: resolver(e.type).finalType,
                    value: e.value,
                });
            });
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
            flatternStruct(arg.value, arg.name).forEach(function (e) {
                args_.push({
                    name: e.name,
                    type: resolver(e.type).finalType,
                    value: e.value,
                });
            });
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
            flatternLibraryState(arg.value, arg.name).forEach(function (e) {
                args_.push({
                    name: e.name,
                    type: resolver(e.type).finalType,
                    value: e.value,
                });
            });
        }
        else {
            args_.push({
                name: arg.name,
                type: finalType,
                value: arg.value,
            });
        }
    });
    return args_;
}
exports.flatternStateArgs = flatternStateArgs;
function flatternLibraryParam(param, resolver, property) {
    var libraryClass = resolver.resolverClass(param.type);
    var ast = property ? libraryClass.libraryAst.properties : libraryClass.libraryAst.params;
    return ast
        .map(function (p) {
        var typeInfo = resolver.resolverType(p.type);
        p.type = typeInfo.finalType;
        if (isArrayType(p.type)) {
            return flatternArrayParam({
                name: param.name + "." + p.name,
                type: p.type,
            }, resolver);
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
            return flatternStructParam({
                name: param.name + "." + p.name,
                type: p.type,
            }, resolver);
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
            return flatternLibraryParam({
                name: param.name + "." + p.name,
                type: p.type,
            }, resolver, property);
        }
        else {
            return {
                value: undefined,
                name: param.name + "." + p.name,
                type: p.type,
            };
        }
    })
        .flat(Infinity);
}
function flatternStructParam(param, resolver) {
    var StructClass = resolver.resolverClass(param.type);
    return StructClass.structAst.params
        .map(function (p) {
        var typeInfo = resolver.resolverType(p.type);
        p.type = typeInfo.finalType;
        if (isArrayType(p.type)) {
            return flatternArrayParam({
                name: param.name + "." + p.name,
                type: p.type,
            }, resolver);
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
            return flatternStructParam({
                name: param.name + "." + p.name,
                type: p.type,
            }, resolver);
        }
        else {
            return {
                value: undefined,
                name: param.name + "." + p.name,
                type: p.type,
            };
        }
    })
        .flat(Infinity);
}
function flatternArrayParam(param, resolver) {
    var typeInfo = resolver.resolverType(param.type);
    param.type = typeInfo.finalType;
    if (!isArrayType(param.type)) {
        throw new Error("ParamEntity " + param.name + " should be array");
    }
    var _a = __read(arrayTypeAndSize(param.type), 2), elemTypeName = _a[0], arraySizes = _a[1];
    var args = [];
    for (var index = 0; index < arraySizes[0]; index++) {
        if (arraySizes.length > 1) {
            flatternArrayParam({
                name: param.name + "[" + index + "]",
                type: subArrayType(param.type),
            }, resolver).forEach(function (a) {
                args.push(a);
            });
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
            flatternStructParam({
                name: param.name + "[" + index + "]",
                type: elemTypeName,
            }, resolver).forEach(function (a) {
                args.push(a);
            });
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
            flatternLibraryParam({
                name: param.name + "[" + index + "]",
                type: elemTypeName,
            }, resolver, true).forEach(function (a) {
                args.push(a);
            });
        }
        else {
            args.push({
                value: undefined,
                name: "" + param.name + subscript(index, arraySizes),
                type: elemTypeName,
            });
        }
    }
    return args.flat(Infinity);
}
function flatternParams(params, resolver) {
    var args_ = [];
    params.forEach(function (param) {
        var typeInfo = resolver.resolverType(param.type);
        param.type = typeInfo.finalType;
        if (isArrayType(param.type)) {
            flatternArrayParam(param, resolver).forEach(function (e) {
                args_.push({
                    name: e.name,
                    type: e.type,
                    value: e.value,
                });
            });
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
            flatternStructParam(param, resolver).forEach(function (e) {
                args_.push({
                    name: e.name,
                    type: e.type,
                    value: e.value,
                });
            });
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
            flatternLibraryParam(param, resolver, true).forEach(function (e) {
                args_.push({
                    name: e.name,
                    type: e.type,
                    value: e.value,
                });
            });
        }
        else {
            args_.push({
                name: param.name,
                type: param.type,
                value: undefined,
            });
        }
    });
    return args_;
}
exports.flatternParams = flatternParams;
function typeOfArg(arg) {
    if (arg instanceof internal_1.ScryptType) {
        var scryptType = arg.finalType;
        return scryptType;
    }
    var typeofArg = typeof arg;
    if (typeofArg === 'boolean') {
        return 'bool';
    }
    if (typeofArg === 'number') {
        return 'int';
    }
    if (typeofArg === 'bigint') {
        return 'int';
    }
    if (typeofArg === 'string') {
        return new internal_1.Int(arg).finalType;
    }
    return typeof arg;
}
exports.typeOfArg = typeOfArg;
function readFileByLine(path, index) {
    var result = '';
    fs.readFileSync(path, 'utf8')
        .split(/\r?\n/)
        .every(function (line, i) {
        if (i === index - 1) {
            result = line;
            return false;
        }
        return true;
    });
    return result;
}
exports.readFileByLine = readFileByLine;
function isEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}
exports.isEmpty = isEmpty;
function compileContract(file, options) {
    console.log("Compiling contract " + file + " ...");
    options = Object.assign({
        out: path_1.join(__dirname, '../out'),
        sourceMap: false,
        desc: false,
    }, options);
    if (!fs.existsSync(file)) {
        throw "file " + file + " not exists!";
    }
    if (!fs.existsSync(options.out)) {
        fs.mkdirSync(options.out);
    }
    var result = internal_1.compile({ path: file }, {
        desc: options.desc,
        outputDir: options.out,
        sourceMap: options.sourceMap,
        cmdPrefix: internal_1.findCompiler(),
    });
    return result;
}
exports.compileContract = compileContract;
function compileContractAsync(file, options) {
    console.log("compiling contract " + file + " ...");
    options = Object.assign({
        out: path_1.join(__dirname, '..', 'out'),
        sourceMap: false,
        desc: false,
    }, options);
    if (!fs.existsSync(file)) {
        throw "file " + file + " not exists!";
    }
    if (!fs.existsSync(options.out)) {
        fs.mkdirSync(options.out);
    }
    return compilerWrapper_1.compileAsync({ path: file }, {
        desc: options.desc,
        outputDir: options.out,
        hex: true,
        cmdPrefix: internal_1.findCompiler(),
    });
}
exports.compileContractAsync = compileContractAsync;
function newCall(Cls, args) {
    return new (Function.prototype.bind.apply(Cls, [null].concat(args)))();
}
exports.newCall = newCall;
function genLaunchConfigFile(constructorArgs, pubFuncArgs, pubFunc, name, program, txContext, asmArgs) {
    // some desc without sourceMap will not have file property.
    if (!program) {
        return '';
    }
    var debugConfig = {
        type: 'scrypt',
        request: 'launch',
        internalConsoleOptions: 'openOnSessionStart',
        name: name,
        program: program,
        constructorArgs: constructorArgs,
        pubFunc: pubFunc,
        pubFuncArgs: pubFuncArgs,
    };
    var debugTxContext = {};
    if (!isEmpty(txContext)) {
        var tx = txContext.tx || '';
        var inputIndex = txContext.inputIndex || 0;
        var inputSatoshis = txContext.inputSatoshis || 0;
        if (tx) {
            Object.assign(debugTxContext, { hex: tx.toString(), inputIndex: inputIndex, inputSatoshis: inputSatoshis });
        }
        if (txContext.opReturn) {
            Object.assign(debugTxContext, { opReturn: txContext.opReturn });
        }
        else if (txContext.opReturnHex) {
            Object.assign(debugTxContext, { opReturnHex: txContext.opReturnHex });
        }
    }
    if (!isEmpty(asmArgs)) {
        Object.assign(debugConfig, { asmArgs: asmArgs });
    }
    if (!isEmpty(debugTxContext)) {
        Object.assign(debugConfig, { txContext: debugTxContext });
    }
    var launch = {
        version: '0.2.0',
        configurations: [debugConfig],
    };
    var jsonstr = JSON.stringify(launch, function (key, value) {
        if (typeof value === 'bigint') {
            return value.toString();
        }
        else {
            return value;
        }
    }, 2);
    if (isNode()) {
        var filename = name + "-launch.json";
        var file = path_1.join(fs.mkdtempSync("" + os_1.tmpdir() + path_1.sep + "sCrypt."), filename);
        fs.writeFileSync(file, jsonstr);
        return path2uri(file);
    }
    else {
        console.error(pubFunc + "() call fail, see launch.json", jsonstr);
    }
}
exports.genLaunchConfigFile = genLaunchConfigFile;
function resolveConstValue(node) {
    var value = undefined;
    if (node.expr.nodeType === 'IntLiteral') {
        value = node.expr.value.toString(10);
    }
    else if (node.expr.nodeType === 'BoolLiteral') {
        value = node.expr.value;
    }
    if (node.expr.nodeType === 'BytesLiteral') {
        value = "b'" + node.expr.value.map(function (a) { return intValue2hex(a); }).join('') + "'";
    }
    if (node.expr.nodeType === 'FunctionCall') {
        if ([
            internal_1.VariableType.PUBKEY,
            internal_1.VariableType.RIPEMD160,
            internal_1.VariableType.PUBKEYHASH,
            internal_1.VariableType.SIG,
            internal_1.VariableType.SIGHASHTYPE,
            internal_1.VariableType.OPCODETYPE,
            internal_1.VariableType.SIGHASHPREIMAGE,
            internal_1.VariableType.SHA1,
            internal_1.VariableType.SHA256,
        ].includes(node.expr.name)) {
            value = "b'" + node.expr.params[0].value.map(function (a) { return intValue2hex(a); }).join('') + "'";
        }
        else if (node.expr.name === internal_1.VariableType.PRIVKEY) {
            value = node.expr.params[0].value.toString(10);
        }
    }
    return value;
}
exports.resolveConstValue = resolveConstValue;
function resolveType(type, originTypes, contract, statics, alias, librarys) {
    var typeInfo = resolveAliasType(originTypes, alias, type);
    if (isArrayType(typeInfo.finalType)) {
        return {
            finalType: resolveArrayType(contract, typeInfo.finalType, statics),
            symbolType: typeInfo.symbolType,
        };
    }
    return typeInfo;
}
exports.resolveType = resolveType;
function resolveArrayType(contract, type, statics) {
    if (isArrayType(type)) {
        var _a = __read(arrayTypeAndSizeStr(type), 2), elemTypeName = _a[0], arraySizes = _a[1];
        var sizes = arraySizes.map(function (size) {
            if (/^(\d)+$/.test(size)) {
                return parseInt(size);
            }
            else {
                // size as a static const
                var size_ = size.indexOf('.') > 0 ? size : contract + "." + size;
                var value = findConstStatic(statics, size_);
                if (!value) {
                    // Unable to solve when the subscript of the array is a function parameter, [CTC](https://scryptdoc.readthedocs.io/en/latest/ctc.html)
                    return size;
                }
                return value.value;
            }
        });
        return toLiteralArrayType(elemTypeName, sizes);
    }
    return type;
}
function resolveAliasType(originTypes, alias, type) {
    if (isArrayType(type)) {
        var _a = __read(arrayTypeAndSizeStr(type), 2), elemTypeName = _a[0], sizes = _a[1];
        var elemTypeInfo = resolveAliasType(originTypes, alias, elemTypeName);
        if (isArrayType(elemTypeInfo.finalType)) {
            var _b = __read(arrayTypeAndSizeStr(elemTypeInfo.finalType), 2), elemTypeName_ = _b[0], sizes_ = _b[1];
            return {
                finalType: toLiteralArrayType(elemTypeName_, sizes.concat(sizes_)),
                symbolType: elemTypeInfo.symbolType,
            };
        }
        return {
            finalType: toLiteralArrayType(elemTypeInfo.finalType, sizes),
            symbolType: elemTypeInfo.symbolType,
        };
    }
    else if (isGenericType(type)) {
        var _c = __read(parseGenericType(type), 2), name_1 = _c[0], genericTypes = _c[1];
        var typeInfo = resolveAliasType(originTypes, alias, name_1);
        var gts = genericTypes.map(function (t) { return resolveAliasType(originTypes, alias, t).finalType; });
        return {
            finalType: toGenericType(typeInfo.finalType, gts),
            symbolType: typeInfo.symbolType,
        };
    }
    var a = alias.find(function (a) {
        return a.name === type;
    });
    if (a) {
        return resolveAliasType(originTypes, alias, a.type);
    }
    else if (originTypes[type]) {
        return originTypes[type];
    }
    else if (scryptTypes_1.BasicScryptType[type]) {
        return {
            finalType: type,
            symbolType: scryptTypes_1.SymbolType.BaseType,
        };
    }
    else {
        return {
            finalType: type,
            symbolType: scryptTypes_1.SymbolType.Unknown,
        };
    }
}
function ansiRegex(_a) {
    var _b = (_a === void 0 ? {} : _a).onlyFirst, onlyFirst = _b === void 0 ? false : _b;
    var pattern = [
        '[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:[a-zA-Z\\d]*(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)',
        '(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))',
    ].join('|');
    return new RegExp(pattern, onlyFirst ? undefined : 'g');
}
exports.ansiRegex = ansiRegex;
function stripAnsi(string) {
    if (typeof string !== 'string') {
        throw new TypeError("Expected a `string`, got `" + typeof string + "`");
    }
    return string.replace(ansiRegex(), '');
}
exports.stripAnsi = stripAnsi;
function createStruct(resolver, param, opcodesMap) {
    var structClass = resolver.resolverClass(param.type);
    var obj = Object.create({});
    structClass.structAst.params.forEach(function (p) {
        var _a, _b, _c, _d;
        var typeInfo = resolver.resolverType(p.type);
        if (isArrayType(typeInfo.finalType)) {
            Object.assign(obj, (_a = {},
                _a[p.name] = createArray(resolver, typeInfo.finalType, param.name + "." + p.name, opcodesMap),
                _a));
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
            Object.assign(obj, (_b = {},
                _b[p.name] = createStruct(resolver, { name: param.name + "." + p.name, type: p.type }, opcodesMap),
                _b));
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
            Object.assign(obj, (_c = {},
                _c[p.name] = createLibrary(resolver, { name: param.name + "." + p.name, type: p.type }, opcodesMap),
                _c));
        }
        else {
            Object.assign(obj, (_d = {},
                _d[p.name] = hex2ScryptType(typeInfo.finalType, opcodesMap.get("<" + param.name + "." + p.name + ">")),
                _d));
        }
    });
    return new structClass(obj);
}
exports.createStruct = createStruct;
function createLibrary(resolver, param, opcodesMap) {
    var libraryClass = resolver.resolverClass(param.type);
    var args = libraryClass.libraryAst.params.map(function (p) {
        var typeInfo = resolver.resolverType(p.type);
        if (isArrayType(typeInfo.finalType)) {
            return createArray(resolver, typeInfo.finalType, param.name + "." + p.name, opcodesMap);
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
            return createStruct(resolver, { name: param.name + "." + p.name, type: p.type }, opcodesMap);
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
            return createLibrary(resolver, { name: param.name + "." + p.name, type: p.type }, opcodesMap);
        }
        else {
            return hex2ScryptType(typeInfo.finalType, opcodesMap.get("<" + param.name + "." + p.name + ">"));
        }
    });
    return new (libraryClass.bind.apply(libraryClass, __spread([void 0], args)))();
}
exports.createLibrary = createLibrary;
function createLibraryProperties(resolver, param, opcodesMap) {
    var libraryClass = resolver.resolverClass(param.type);
    var properties = {};
    libraryClass.libraryAst.properties.forEach(function (p) {
        var _a, _b, _c, _d;
        var typeInfo = resolver.resolverType(p.type);
        if (isArrayType(typeInfo.finalType)) {
            Object.assign(properties, (_a = {},
                _a[p.name] = createArray(resolver, p.type, param.name + "." + p.name, opcodesMap),
                _a));
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
            Object.assign(properties, (_b = {},
                _b[p.name] = createStruct(resolver, { name: param.name + "." + p.name, type: p.type }, opcodesMap),
                _b));
        }
        else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
            var library = createDefaultLibrary(resolver, { name: param.name + "." + p.name, type: p.type });
            library.setProperties(createLibraryProperties(resolver, { name: param.name + "." + p.name, type: p.type }, opcodesMap));
            Object.assign(properties, (_c = {},
                _c[p.name] = library,
                _c));
        }
        else {
            Object.assign(properties, (_d = {},
                _d[p.name] = hex2ScryptType(typeInfo.finalType, opcodesMap.get("<" + param.name + "." + p.name + ">")),
                _d));
        }
    });
    return properties;
}
exports.createLibraryProperties = createLibraryProperties;
function createDefaultLibrary(resolver, param) {
    var flatternparams = flatternLibraryParam(param, resolver, false);
    var hexTemplateMap = new Map();
    flatternparams.forEach(function (p) {
        if (p.type === internal_1.VariableType.INT || p.type === internal_1.VariableType.PRIVKEY) {
            hexTemplateMap.set("<" + p.name + ">", '00');
        }
        else if (p.type === internal_1.VariableType.BOOL) {
            hexTemplateMap.set("<" + p.name + ">", '51');
        }
        else if (p.type === internal_1.VariableType.BYTES ||
            p.type === internal_1.VariableType.PUBKEY ||
            p.type === internal_1.VariableType.SIG ||
            p.type === internal_1.VariableType.RIPEMD160 ||
            p.type === internal_1.VariableType.SHA1 ||
            p.type === internal_1.VariableType.SHA256 ||
            p.type === internal_1.VariableType.SIGHASHTYPE ||
            p.type === internal_1.VariableType.SIGHASHPREIMAGE ||
            p.type === internal_1.VariableType.OPCODETYPE) {
            hexTemplateMap.set("<" + p.name + ">", '0100');
        }
        else {
            throw new Error("param " + p.name + " has unknown type " + p.type);
        }
    });
    return createLibrary(resolver, param, hexTemplateMap);
}
exports.createDefaultLibrary = createDefaultLibrary;
function createArray(resolver, type, name, opcodesMap) {
    var arrays = [];
    var _a = __read(arrayTypeAndSize(type), 2), elemTypeName = _a[0], sizes = _a[1];
    var arraylen = sizes[0];
    if (sizes.length === 1) {
        for (var index = 0; index < arraylen; index++) {
            var typeInfo = resolver.resolverType(elemTypeName);
            if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
                arrays.push(createStruct(resolver, {
                    name: name + "[" + index + "]",
                    type: typeInfo.finalType,
                }, opcodesMap));
            }
            else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
                arrays.push(createLibrary(resolver, {
                    name: name + "[" + index + "]",
                    type: typeInfo.finalType,
                }, opcodesMap));
            }
            else {
                arrays.push(hex2ScryptType(typeInfo.finalType, opcodesMap.get("<" + name + "[" + index + "]>")));
            }
        }
    }
    else {
        for (var index = 0; index < arraylen; index++) {
            var finalType = resolver.resolverType(elemTypeName).finalType;
            var subArrayType_1 = [
                finalType,
                sizes
                    .slice(1)
                    .map(function (size) { return "[" + size + "]"; })
                    .join(''),
            ].join('');
            arrays.push(createArray(resolver, subArrayType_1, name + "[" + index + "]", opcodesMap));
        }
    }
    return arrays;
}
exports.createArray = createArray;
function toLiteral(value) {
    if (Array.isArray(value)) {
        var v = value;
        return "[" + v.map(function (i) { return toLiteral(i); }) + "]";
    }
    else {
        return value instanceof internal_1.ScryptType ? value.toLiteral() : value;
    }
}
exports.toLiteral = toLiteral;
function isInteger(x) {
    // check if the passed value is a number
    if (typeof x == 'number' && !isNaN(x)) {
        // check if it is integer
        return Number.isInteger(x);
    }
    else if (typeof x == 'bigint') {
        return true;
    }
    else if (typeof x == 'string') {
        // hex int
        var m = /^(0x[0-9a-fA-F]+)$/.exec(x);
        if (m) {
            return true;
        }
        // decimal int
        m = /^(-?\d+)$/.exec(x);
        if (m) {
            return true;
        }
        return false;
    }
    return false;
}
exports.isInteger = isInteger;
function findConstStatic(statics, name) {
    return statics.find(function (s) {
        return s.const === true && s.name === name;
    });
}
exports.findConstStatic = findConstStatic;
function findStatic(statics, name) {
    return statics.find(function (s) {
        return s.name === name;
    });
}
exports.findStatic = findStatic;
function escapeRegExp(stringToGoIntoTheRegex) {
    return stringToGoIntoTheRegex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}
// state version
var CURRENT_STATE_VERSION = 0;
function buildContractCode(hexTemplateArgs, hexTemplateInlineASM, hexTemplate) {
    var e_1, _a, e_2, _b;
    var lsHex = hexTemplate;
    try {
        for (var _c = __values(hexTemplateArgs.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var entry = _d.value;
            var name_2 = entry[0];
            var value = entry[1];
            lsHex = lsHex.replace(name_2, value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var _e = __values(hexTemplateInlineASM.entries()), _f = _e.next(); !_f.done; _f = _e.next()) {
            var entry = _f.value;
            var name_3 = entry[0];
            var value = entry[1];
            lsHex = lsHex.replace(new RegExp("" + escapeRegExp(name_3), 'g'), value);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return mvc.Script.fromHex(lsHex);
}
exports.buildContractCode = buildContractCode;
/**
 * only used for state contract
 * @param args
 * @param firstCall
 * @param finalTypeResolver
 * @returns
 */
function buildContractState(args, firstCall, finalTypeResolver) {
    var e_3, _a;
    var state_hex = '';
    var state_len = 0;
    var args_ = flatternStateArgs(args, finalTypeResolver);
    if (args_.length <= 0) {
        throw new Error('no state property found, buildContractState only used for state contract');
    }
    // append firstCall which is a hidden built-in state
    state_hex += "" + internal_1.serializeSupportedParamType(firstCall);
    try {
        for (var args_2 = __values(args_), args_2_1 = args_2.next(); !args_2_1.done; args_2_1 = args_2.next()) {
            var arg = args_2_1.value;
            if (arg.type == internal_1.VariableType.BOOL) {
                //fixed length
                state_hex += "" + internal_1.serializeSupportedParamType(arg.value);
            }
            else if (arg.type === internal_1.VariableType.INT ||
                arg.type === internal_1.VariableType.BYTES ||
                arg.type === internal_1.VariableType.PUBKEY ||
                arg.type === internal_1.VariableType.PRIVKEY ||
                arg.type === internal_1.VariableType.PUBKEY ||
                arg.type === internal_1.VariableType.SIG ||
                arg.type === internal_1.VariableType.RIPEMD160 ||
                arg.type === internal_1.VariableType.SHA1 ||
                arg.type === internal_1.VariableType.SHA256 ||
                arg.type === internal_1.VariableType.SIGHASHTYPE ||
                arg.type === internal_1.VariableType.SIGHASHPREIMAGE ||
                arg.type === internal_1.VariableType.OPCODETYPE) {
                state_hex += "" + mvc.Script.fromASM(internal_1.serializeSupportedParamType(arg.value)).toHex();
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (args_2_1 && !args_2_1.done && (_a = args_2.return)) _a.call(args_2);
        }
        finally { if (e_3) throw e_3.error; }
    }
    //append meta
    if (state_hex) {
        state_len = state_hex.length / 2;
        state_hex += num2bin(state_len, 4) + num2bin(CURRENT_STATE_VERSION, 1);
        return state_hex;
    }
    return state_hex;
}
exports.buildContractState = buildContractState;
function buildDefaultStateProps(contract) {
    var flatternparams = flatternParams(contract.stateProps, contract.resolver);
    var hexTemplateMap = new Map();
    flatternparams.forEach(function (p) {
        if (p.type === internal_1.VariableType.INT || p.type === internal_1.VariableType.PRIVKEY) {
            hexTemplateMap.set("<" + p.name + ">", '00');
        }
        else if (p.type === internal_1.VariableType.BOOL) {
            hexTemplateMap.set("<" + p.name + ">", '51');
        }
        else if (p.type === internal_1.VariableType.BYTES ||
            p.type === internal_1.VariableType.PUBKEY ||
            p.type === internal_1.VariableType.SIG ||
            p.type === internal_1.VariableType.RIPEMD160 ||
            p.type === internal_1.VariableType.SHA1 ||
            p.type === internal_1.VariableType.SHA256 ||
            p.type === internal_1.VariableType.SIGHASHTYPE ||
            p.type === internal_1.VariableType.SIGHASHPREIMAGE ||
            p.type === internal_1.VariableType.OPCODETYPE) {
            hexTemplateMap.set("<" + p.name + ">", '0100');
        }
        else {
            throw new Error("param " + p.name + " has unknown type " + p.type);
        }
    });
    return contract.stateProps.map(function (param) {
        return deserializeArgfromState(contract.resolver, Object.assign(param, {
            value: undefined,
        }), hexTemplateMap);
    });
}
exports.buildDefaultStateProps = buildDefaultStateProps;
function readBytes(br) {
    try {
        var opcodenum = br.readUInt8();
        var len_1, data = void 0;
        if (opcodenum == 0) {
            data = '';
        }
        else if (opcodenum > 0 && opcodenum < mvc.Opcode.OP_PUSHDATA1) {
            len_1 = opcodenum;
            data = br.read(len_1).toString('hex');
        }
        else if (opcodenum === mvc.Opcode.OP_PUSHDATA1) {
            len_1 = br.readUInt8();
            data = br.read(len_1).toString('hex');
        }
        else if (opcodenum === mvc.Opcode.OP_PUSHDATA2) {
            len_1 = br.readUInt16LE();
            data = br.read(len_1).toString('hex');
        }
        else if (opcodenum === mvc.Opcode.OP_PUSHDATA4) {
            len_1 = br.readUInt32LE();
            data = br.read(len_1).toString('hex');
        }
        else {
            data = num2bin(opcodenum - 80, 1);
        }
        return {
            data: data,
            opcodenum: opcodenum,
        };
    }
    catch (e) {
        throw new Error('readBytes: ' + e);
    }
}
exports.readBytes = readBytes;
function deserializeArgfromHex(resolver, arg, opcodesMap) {
    var value;
    var typeInfo = resolver.resolverType(arg.type);
    if (isArrayType(typeInfo.finalType)) {
        value = createArray(resolver, arg.type, arg.name, opcodesMap);
    }
    else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
        value = createStruct(resolver, arg, opcodesMap);
    }
    else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
        value = createLibrary(resolver, arg, opcodesMap);
    }
    else {
        value = hex2ScryptType(arg.type, opcodesMap.get("<" + arg.name + ">"));
    }
    arg.value = value;
    return arg;
}
exports.deserializeArgfromHex = deserializeArgfromHex;
function deserializeArgfromState(resolver, arg, opcodesMap) {
    var value;
    var typeInfo = resolver.resolverType(arg.type);
    if (isArrayType(typeInfo.finalType)) {
        value = createArray(resolver, arg.type, arg.name, opcodesMap);
    }
    else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Struct) {
        value = createStruct(resolver, arg, opcodesMap);
    }
    else if (typeInfo.symbolType === scryptTypes_1.SymbolType.Library) {
        value = createDefaultLibrary(resolver, arg);
        var properties = createLibraryProperties(resolver, arg, opcodesMap);
        value.setProperties(properties);
    }
    else {
        value = hex2ScryptType(arg.type, opcodesMap.get("<" + arg.name + ">"));
    }
    arg.value = value;
    return arg;
}
exports.deserializeArgfromState = deserializeArgfromState;
/**
 *
 * @param data
 * @returns flat ScryptType array
 */
function flattenData(data) {
    if (Array.isArray(data)) {
        return data
            .map(function (item) {
            return flattenData(item);
        })
            .flat(Infinity);
    }
    else if (internal_1.Struct.isStruct(data)) {
        var argS_2 = data;
        var keys = argS_2.getMembers();
        return keys
            .map(function (key) {
            var member = argS_2.memberByKey(key);
            return flattenData(member);
        })
            .flat(Infinity);
    }
    else if (typeof data === 'boolean') {
        return [new internal_1.Bool(data)];
    }
    else if (typeof data === 'number' || typeof data === 'bigint' || typeof data === 'string') {
        return [new internal_1.Int(data)];
    }
    else if (data instanceof internal_1.ScryptType) {
        return [data];
    }
}
// struct / array: sha256 every single element of the flattened struct / array, and concat the result to a joint byte, and sha256 again
// basic type: sha256 every single element
function flattenSha256(data) {
    var flattened = flattenData(data);
    if (flattened.length === 1) {
        var hex = flattened[0].serialize();
        if ((flattened[0] instanceof internal_1.Bool || flattened[0] instanceof internal_1.Int) && hex === '00') {
            hex = '';
        }
        return mvc.crypto.Hash.sha256(Buffer.from(hex, 'hex')).toString('hex');
    }
    else {
        var jointbytes = flattened
            .map(function (item) {
            var hex = item.serialize();
            if ((item instanceof internal_1.Bool || item instanceof internal_1.Int) && hex === '00') {
                hex = '';
            }
            return mvc.crypto.Hash.sha256(Buffer.from(hex, 'hex')).toString('hex');
        })
            .join('');
        return mvc.crypto.Hash.sha256(Buffer.from(jointbytes, 'hex')).toString('hex');
    }
}
exports.flattenSha256 = flattenSha256;
// sort the map by the result of flattenSha256 of the key
function sortmap(map) {
    return new Map(__spread(map.entries()).sort(function (a, b) {
        return BN.fromSM(Buffer.from(flattenSha256(a[0]), 'hex'), {
            endian: 'little',
        }).cmp(BN.fromSM(Buffer.from(flattenSha256(b[0]), 'hex'), {
            endian: 'little',
        }));
    }));
}
exports.sortmap = sortmap;
// sort the set by the result of flattenSha256 of the key
function sortset(set) {
    return new Set(__spread(set.keys()).sort(function (a, b) {
        return BN.fromSM(Buffer.from(flattenSha256(a), 'hex'), {
            endian: 'little',
        }).cmp(BN.fromSM(Buffer.from(flattenSha256(b), 'hex'), {
            endian: 'little',
        }));
    }));
}
exports.sortset = sortset;
// returns index of the HashedMap/HashedSet by the key
function findKeyIndex(collection, key) {
    var e_4, _a, e_5, _b;
    if (collection instanceof Map) {
        var sortedMap = sortmap(collection);
        var m = [];
        try {
            for (var _c = __values(sortedMap.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var entry = _d.value;
                m.push(entry);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return m.findIndex(function (entry) {
            if (entry[0] === key) {
                return true;
            }
            return false;
        });
    }
    else {
        var sortedSet = sortset(collection);
        var m = [];
        try {
            for (var _e = __values(sortedSet.keys()), _f = _e.next(); !_f.done; _f = _e.next()) {
                var entry = _f.value;
                m.push(entry);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return m.findIndex(function (entry) {
            if (entry === key) {
                return true;
            }
            return false;
        });
    }
}
exports.findKeyIndex = findKeyIndex;
// serialize the HashedMap/HashedSet, but only flattenSha256 of the key and value
function toData(collection) {
    var e_6, _a, e_7, _b;
    var storage = '';
    if (collection instanceof Map) {
        var sortedMap = sortmap(collection);
        try {
            for (var _c = __values(sortedMap.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var entry = _d.value;
                storage += flattenSha256(entry[0]) + flattenSha256(entry[1]);
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_6) throw e_6.error; }
        }
    }
    else {
        var sortedSet = sortset(collection);
        try {
            for (var _e = __values(sortedSet.keys()), _f = _e.next(); !_f.done; _f = _e.next()) {
                var key = _f.value;
                storage += flattenSha256(key);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_7) throw e_7.error; }
        }
    }
    return new internal_1.Bytes(storage);
}
exports.toData = toData;
function toHashedMap(collection) {
    var data = toData(collection);
    var hashedMap = new scryptTypes_1.HashedMap(data);
    return hashedMap;
}
exports.toHashedMap = toHashedMap;
function toHashedSet(collection) {
    var data = toData(collection);
    var hashedSet = new scryptTypes_1.HashedSet(data);
    return hashedSet;
}
exports.toHashedSet = toHashedSet;
/**
 * check if a type is generic type
 * @param type
 * @returns
 */
function isGenericType(type) {
    return /^([\w]+)<([\w,[\]\s<>]+)>$/.test(type);
}
exports.isGenericType = isGenericType;
/**
 *
 * @param type eg. HashedMap<int,int>
 * @param eg. ["HashedMap", ["int", "int"]}] An array generic types returned by @getGenericDeclaration
 * @returns {"K": "int", "V": "int"}
 */
function parseGenericType(type) {
    if (isGenericType(type)) {
        var m = type.match(/([\w]+)<([\w,[\]<>\s]+)>$/);
        if (m) {
            var library = m[1];
            var realTypes = [];
            var brackets = [];
            var tmpType = '';
            for (var i = 0; i < m[2].length; i++) {
                var ch = m[2].charAt(i);
                if (ch === '<' || ch === '[') {
                    brackets.push(ch);
                }
                else if (ch === '>' || ch === ']') {
                    brackets.pop();
                }
                else if (ch === ',') {
                    if (brackets.length === 0) {
                        realTypes.push(tmpType.trim());
                        tmpType = '';
                        continue;
                    }
                }
                tmpType += ch;
            }
            realTypes.push(tmpType.trim());
            return [library, realTypes];
        }
    }
    throw new Error("\"" + type + "\" is not generic type");
}
exports.parseGenericType = parseGenericType;
// Equivalent to the built-in function `hash160` in scrypt
function hash160(hexstr, encoding) {
    return mvc.crypto.Hash.sha256ripemd160(Buffer.from(hexstr, encoding || 'hex')).toString('hex');
}
exports.hash160 = hash160;
// Equivalent to the built-in function `sha256` in scrypt
function sha256(hexstr, encoding) {
    return mvc.crypto.Hash.sha256(Buffer.from(hexstr, encoding || 'hex')).toString('hex');
}
exports.sha256 = sha256;
// Equivalent to the built-in function `hash256` in scrypt
function hash256(hexstr, encoding) {
    return sha256(sha256(hexstr, encoding), encoding);
}
exports.hash256 = hash256;
var LINKPATTERN = /(\[((!\[[^\]]*?\]\(\s*)([^\s()]+?)\s*\)\]|(?:\\\]|[^\]])*\])\(\s*)(([^\s()]|\([^\s()]*?\))+)\s*(".*?")?\)/g;
function readLaunchJson(error) {
    var e_8, _a;
    try {
        for (var _b = __values(error.matchAll(LINKPATTERN)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var match = _c.value;
            if (match[5] && match[5].startsWith('scryptlaunch')) {
                var file = match[5].replace(/scryptlaunch/, 'file');
                return JSON.parse(fs.readFileSync(uri2path(file)).toString());
            }
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_8) throw e_8.error; }
    }
    return undefined;
}
exports.readLaunchJson = readLaunchJson;
// Equivalent to the built-in function `len` in scrypt
function len(hexstr) {
    return hexstr.length / 2;
}
exports.len = len;
// convert signed integer `n` to unsigned integer of `l` bytes, in little endian
function toLEUnsigned(n, l) {
    // one extra byte to accommodate possible negative sign byte
    var m = num2bin(n, l + 1);
    // remove sign byte
    return m.slice(0, len(m) - 1);
}
exports.toLEUnsigned = toLEUnsigned;
// convert 'b' to a VarInt field, including the preceding length
function writeVarint(b) {
    var n = len(b);
    var header = '';
    if (n < 0xfd) {
        header = toLEUnsigned(n, 1);
    }
    else if (n < 0x10000) {
        header = 'fd' + toLEUnsigned(n, 2);
    }
    else if (n < 0x100000000) {
        header = 'fe' + toLEUnsigned(n, 4);
    }
    else if (n < 0x10000000000000000) {
        header = 'ff' + toLEUnsigned(n, 8);
    }
    return header + b;
}
exports.writeVarint = writeVarint;
function buildOpreturnScript(data) {
    return mvc.Script.fromASM(['OP_FALSE', 'OP_RETURN', data].join(' '));
}
exports.buildOpreturnScript = buildOpreturnScript;
function buildPublicKeyHashScript(pubKeyHash) {
    return mvc.Script.fromASM(['OP_DUP', 'OP_HASH160', pubKeyHash.toASM(), 'OP_EQUALVERIFY', 'OP_CHECKSIG'].join(' '));
}
exports.buildPublicKeyHashScript = buildPublicKeyHashScript;
/**
 * Parse out which public function is called through unlocking script
 * @param contract
 * @param hex hex of unlocking script
 * @returns return ABIEntity of the public function which is call by the unlocking script
 */
function parseAbiFromUnlockingScript(contract, hex) {
    var abis = Object.getPrototypeOf(contract).constructor.abi;
    var pubFunAbis = abis.filter(function (entity) { return entity.type === 'function'; });
    var pubFunCount = pubFunAbis.length;
    if (pubFunCount === 1) {
        return pubFunAbis[0];
    }
    var script = mvc.Script.fromHex(hex);
    var usASM = script.toASM();
    var pubFuncIndexASM = usASM.substr(usASM.lastIndexOf(' ') + 1);
    var pubFuncIndex = asm2int(pubFuncIndexASM);
    var entity = abis.find(function (entity) { return entity.index === pubFuncIndex; });
    if (!entity) {
        throw new Error("the raw unlocking script cannot match the contract " + contract.contractName);
    }
    return entity;
}
exports.parseAbiFromUnlockingScript = parseAbiFromUnlockingScript;
function toScryptType(a) {
    if (typeof a === 'number' || typeof a === 'bigint' || typeof a === 'string') {
        return new internal_1.Int(a);
    }
    else if (typeof a === 'boolean') {
        return new internal_1.Bool(a);
    }
    else if (a instanceof internal_1.ScryptType) {
        return a;
    }
    else {
        throw a + " cannot be convert to ScryptType";
    }
}
exports.toScryptType = toScryptType;
function arrayToScryptType(a) {
    return a.map(function (i) {
        if (Array.isArray(i)) {
            return arrayToScryptType(i);
        }
        return toScryptType(i);
    });
}
exports.arrayToScryptType = arrayToScryptType;
function arrayToJson(a) {
    return a.map(function (i) {
        if (Array.isArray(i)) {
            return arrayToJson(i);
        }
        return toScryptType(i).toJSON();
    });
}
exports.arrayToJson = arrayToJson;
function cloneArray(a) {
    return a.map(function (i) {
        if (Array.isArray(i)) {
            return cloneArray(i);
        }
        return toScryptType(i).clone();
    });
}
exports.cloneArray = cloneArray;
function inferrType(a) {
    if (Array.isArray(a)) {
        if (a.length === 0) {
            throw new Error('cannot inferr type from empty array');
        }
        var arg0_1 = a[0];
        if (Array.isArray(arg0_1)) {
            if (!a.every(function (arg) { return Array.isArray(arg) && arg.length === arg0_1.length; })) {
                throw new Error("cannot inferr type from [" + a + "] , not all length of element are the same");
            }
            var _a = __read(arrayTypeAndSize(inferrType(arg0_1)), 2), e = _a[0], sizes = _a[1];
            return toLiteralArrayType(e, [a.length].concat(sizes));
        }
        else {
            var t_1 = typeOfArg(arg0_1);
            if (!a.every(function (arg) { return typeOfArg(arg) === t_1; })) {
                throw new Error("cannot inferr type from [" + a + "] , not all element types are the same");
            }
            return toScryptType(a[0]).finalType + "[" + a.length + "]";
        }
    }
    else {
        return toScryptType(a).finalType;
    }
}
exports.inferrType = inferrType;
function resolveGenericType(genericTypeMap, type) {
    if (Object.keys(genericTypeMap).length > 0) {
        if (isGenericType(type)) {
            var _a = __read(parseGenericType(type), 2), name_4 = _a[0], types = _a[1];
            return toGenericType(name_4, types.map(function (t) { return genericTypeMap[t] || t; }));
        }
        if (isArrayType(type)) {
            var _b = __read(arrayTypeAndSizeStr(type), 2), elem = _b[0], sizes = _b[1];
            return toLiteralArrayType(elem, sizes.map(function (t) { return genericTypeMap[t] || t; }));
        }
        return genericTypeMap[type] || type;
    }
    return type;
}
exports.resolveGenericType = resolveGenericType;
function librarySign(genericEntity) {
    return "[" + genericEntity.params.map(function (p) { return p.type; }).join(',') + "]";
}
exports.librarySign = librarySign;
function structSign(structEntity) {
    return "" + JSON.stringify(structEntity.params.reduce(function (p, v) {
        var _a;
        return Object.assign(p, (_a = {},
            _a[v.name] = v.type,
            _a));
    }, {}), null, 4);
}
exports.structSign = structSign;
function arrayToLiteral(a) {
    var al = a
        .map(function (i) {
        if (Array.isArray(i)) {
            return arrayToLiteral(i);
        }
        return toScryptType(i).toLiteral();
    })
        .join(',');
    return "[" + al + "]";
}
exports.arrayToLiteral = arrayToLiteral;
// If the property is the same as the construction parameter, there may be no constructor, in which case the construction parameter can be assigned to the property. But this does not guarantee that the property is always correct, the user may have modified the value of the property in the constructor
function canAssignProperty(libraryAst) {
    return (libraryAst.params.length === libraryAst.properties.length &&
        libraryAst.params.every(function (param, index) {
            return param.name === libraryAst.properties[index].name && param.type === libraryAst.properties[index].type;
        }));
}
exports.canAssignProperty = canAssignProperty;
function int2Number(value) {
    if (typeof value === 'number' || typeof value === 'bigint') {
        return value;
    }
    else if (typeof value === 'string') {
        if (value.startsWith('0x')) {
            var bn = new BN(value.substr(2), 16);
            return bn.toNumber();
        }
        else {
            var bn = new BN(value);
            return bn.toNumber();
        }
    }
}
exports.int2Number = int2Number;
function and(a, b) {
    var size1 = a.serialize().length / 2;
    var size2 = b.serialize().length / 2;
    var maxSize = Math.max(size1, size2);
    var ba = Buffer.from(num2bin(a.toNumber(), maxSize), 'hex');
    var bb = Buffer.from(num2bin(b.toNumber(), maxSize), 'hex');
    for (var i = 0; i < ba.length; i++) {
        ba[i] &= bb[i];
    }
    return new internal_1.Int(bin2num(ba));
}
exports.and = and;
function or(a, b) {
    var size1 = a.serialize().length / 2;
    var size2 = b.serialize().length / 2;
    var maxSize = Math.max(size1, size2);
    var ba = Buffer.from(num2bin(a.toNumber(), maxSize), 'hex');
    var bb = Buffer.from(num2bin(b.toNumber(), maxSize), 'hex');
    for (var i = 0; i < ba.length; i++) {
        ba[i] |= bb[i];
    }
    return new internal_1.Int(bin2num(ba));
}
exports.or = or;
function xor(a, b) {
    var size1 = a.serialize().length / 2;
    var size2 = b.serialize().length / 2;
    var maxSize = Math.max(size1, size2);
    var ba = Buffer.from(num2bin(a.toNumber(), maxSize), 'hex');
    var bb = Buffer.from(num2bin(b.toNumber(), maxSize), 'hex');
    for (var i = 0; i < ba.length; i++) {
        ba[i] ^= bb[i];
    }
    return new internal_1.Int(bin2num(ba));
}
exports.xor = xor;
function invert(a) {
    if (a.toNumber() === 0) {
        return a;
    }
    var size = a.serialize().length / 2;
    var buffer = Buffer.from(num2bin(a.toNumber(), size), 'hex');
    for (var i = 0; i < buffer.length; i++) {
        buffer[i] = ~buffer[i];
    }
    return new internal_1.Int(bin2num(buffer));
}
exports.invert = invert;
function JSONParser(file) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    json_ext_1.parseChunked(fs.createReadStream(file))
                        .then(function (data) {
                        resolve(data);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
                })];
        });
    });
}
exports.JSONParser = JSONParser;
function JSONParserSync(file) {
    return JSON.parse(fs.readFileSync(file, 'utf8'));
}
exports.JSONParserSync = JSONParserSync;
function JSONStringify(file, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    json_ext_1.stringifyStream(data)
                        .pipe(fs.createWriteStream(file))
                        .on('finish', function () {
                        resolve(true);
                    })
                        .on('error', function (e) {
                        reject(e);
                    });
                })];
        });
    });
}
exports.JSONStringify = JSONStringify;
function findSrcInfoV2(pc, sourceMap) {
    var decoded = sourcemap_codec_1.decode(sourceMap['mappings']);
    for (var index = 0; index < decoded[0].length; index++) {
        var element = decoded[0][index];
        if (element[0] <= pc) {
            continue;
        }
        return decoded[0][index - 1];
    }
    return decoded[0][decoded[0].length - 1];
}
exports.findSrcInfoV2 = findSrcInfoV2;
/**
 * @deprecated use findSrcInfoV2
 * @param opcodes OpCode[] from sourceMap
 */
function findSrcInfoV1(opcodes, opcodesIndex) {
    while (--opcodesIndex > 0) {
        if (opcodes[opcodesIndex].pos && opcodes[opcodesIndex].pos.file !== 'std' && opcodes[opcodesIndex].pos.line > 0) {
            return opcodes[opcodesIndex];
        }
    }
}
exports.findSrcInfoV1 = findSrcInfoV1;
function parseStateHex(contract, scriptHex) {
    var metaScript = scriptHex.substr(scriptHex.length - 10, 10);
    var version = bin2num(metaScript.substr(metaScript.length - 2, 2));
    var stateLen = bin2num(metaScript.substr(0, 8));
    var stateHex = scriptHex.substr(scriptHex.length - 10 - stateLen * 2, stateLen * 2);
    var br = new mvc.encoding.BufferReader(stateHex);
    var opcodenum = br.readUInt8();
    var firstCall = opcodenum == 1;
    var stateTemplateArgs = new Map();
    var flatternparams = flatternParams(contract.stateProps, contract.resolver);
    flatternparams.forEach(function (param) {
        if (param.type === internal_1.VariableType.BOOL) {
            var opcodenum_1 = br.readUInt8();
            stateTemplateArgs.set("<" + param.name + ">", opcodenum_1 === 1 ? '51' : '00');
        }
        else {
            var data = readBytes(br).data;
            if (param.type === internal_1.VariableType.INT || param.type === internal_1.VariableType.PRIVKEY) {
                stateTemplateArgs.set("<" + param.name + ">", new internal_1.Int(bin2num(data)).toHex());
            }
            else {
                stateTemplateArgs.set("<" + param.name + ">", mvc.Script.fromASM(data).toHex());
            }
        }
    });
    return [
        firstCall,
        contract.stateProps.map(function (param) {
            return deserializeArgfromState(contract.resolver, Object.assign(param, {
                value: undefined,
            }), stateTemplateArgs);
        }),
    ];
}
exports.parseStateHex = parseStateHex;
//# sourceMappingURL=utils.js.map